import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * 「ベストアンサー見出し」文言
	 */
	bestAnswerTitle: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    bestAnswerTitle: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 「ベストアンサー見出し」文言
	 */
	bestAnswerTitle: string;
}
/**
 * リプライ情報 > ベストアンサーアイコン。
 */



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})